export default __webpack_public_path__ + "static/media/public-page-img.f5580533.png";